import { render, staticRenderFns } from "./SrsAgree.vue?vue&type=template&id=068db82d&scoped=true&"
import script from "./SrsAgree.vue?vue&type=script&lang=ts&"
export * from "./SrsAgree.vue?vue&type=script&lang=ts&"
import style0 from "./SrsAgree.vue?vue&type=style&index=0&id=068db82d&scoped=true&lang=scss&"
import style1 from "./SrsAgree.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068db82d",
  null
  
)

export default component.exports